module.exports = __webpack_public_path__ + "media/styles/images/svg/checkbox-checked-gray-1d7a4e72aee09c2be5e8de71dd14605a.svg";